import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "./../axios";
import { newAlert } from "./alertSlice";
import { showModal, showSpinner } from "./sessionSlice";
import moment from "moment";

//#region getDshboardByTimeperiod
export const getDashboardByTimePeriod = createAsyncThunk(
  "supervisor/getDashboarbByTimePeriod",
  async (payload, thunkApi) => {
    try {
      const { toDate, fromDate, timezone } = payload;
      console.log("payload", payload);
      const { data } = await Axios.get(
        `/api/supervisor/get-dashboard-by-timeperiod?toDate=${toDate}&fromDate=${fromDate}&timezone=${timezone}`
      );
      return data.dashboard;
    } catch (error) {
      thunkApi.dispatch(newAlert({ type: "danger", message: "Server Error" }));
      return Promise.reject({ error: { message: error.message } });
    }
  }
);
//#endregion

export const supervisorSlice = createSlice({
  name: "supervisor",
  initialState: {
    selectedDate: moment().toISOString(),
    dashboard: [],
    loading: false
  },
  reducers: {
    //#region Show Modal
    /**
     * payload {
     *    id: "MODAL_ID",
     *    data: { SLOT }
     * }
     */
  },
  extraReducers: {
    //#region getDashboardByTimePeriod
    [getDashboardByTimePeriod.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.dashboard = payload;
    },
    [getDashboardByTimePeriod.rejected]: (state) => {
      state.loading = false;
    },
    [getDashboardByTimePeriod.pending]: (state) => {
      state.loading = true;
    },
    //#endregion
  },
});

//#region Actions Export
export const {} = supervisorSlice.actions;

export default supervisorSlice.reducer;
